import {
  Badge,
  ButtonLink,
  GripVerticalIcon,
  PlusIcon,
  SortableList,
  Stack,
} from '@fukuri-admins/ui/common';
import { TopBannerDropdownMenu } from '../features/TopBannerDropdownMenu';
import styles from './styles.module.scss';

type TopBanner = React.ComponentProps<typeof TopBannerDropdownMenu>['topBanner'] & {
  /** 配信対象ユーザータイプの表示テキスト */
  targetUserTypeLabel: string;
};

type Props = {
  topBanners: TopBanner[];
  createLink: string;
  onReOrder: (items: TopBanner[]) => void;
  onSelectedDropdownMenu: () => void;
};

/**
 * トップバナー一覧のプレゼンテーションコンポーネント
 * NOTE: Contents部分は後日実装
 */
export const TopBannerListPresentation: React.FC<Props> = ({
  topBanners,
  createLink,
  onSelectedDropdownMenu,
  onReOrder,
}) => (
  <div className={styles.content}>
    <div className={styles.header}>
      <span className={styles.title}>バナー</span>
      <ButtonLink
        variant='primary'
        size='md'
        icon={<PlusIcon size='xs' />}
        iconPosition='left'
        to={createLink}
      >
        新規作成
      </ButtonLink>
    </div>
    <Stack direction='column' gap={16}>
      <SortableList
        items={topBanners}
        onReorder={onReOrder}
        renderItem={(
          {
            id,
            title,
            transitionUrl,
            isActive,
            sortOrder,
            imageUrl,
            groupName,
            targetUserTypeLabel,
          },
          dragHandleProps
        ) => (
          <div key={id} className={styles.bannerItem}>
            <div
              className={styles.bannerItemIcon}
              {...dragHandleProps.attributes}
              {...dragHandleProps.listeners}
            >
              <GripVerticalIcon size='xs' />
            </div>
            <div className={styles.bannerItemContent}>
              <div className={styles.bannerItemSortOrder}>{sortOrder}</div>
              <div className={styles.bannerItemStatus}>
                <Badge
                  status={isActive ? 'success' : 'neutral'}
                  variant='subtle'
                  size='sm'
                  label={isActive ? '表示中' : '非表示'}
                />
              </div>
              <div className={styles.bannerItemImage} data-active={isActive}>
                <img src={imageUrl} alt={title} />
              </div>
              <div className={styles.bannerItemInfo}>
                <div className={styles.bannerItemInfoTitle}>{title}</div>
                <Stack direction='row' gap={8} className={styles.bannerItemInfoTransitionUrl}>
                  <span>遷移先</span>
                  <a href={transitionUrl} target='_blank' rel='noopener noreferrer'>
                    {transitionUrl}
                  </a>
                </Stack>
                <Stack direction='row' gap={8} className={styles.bannerItemInfoGroupName}>
                  <span>配信先</span>
                  <span>{groupName}</span>
                </Stack>
                <Stack direction='row' gap={8} className={styles.bannerItemInfoTargetUserType}>
                  <span>配信対象</span>
                  <span>{targetUserTypeLabel}</span>
                </Stack>
              </div>
            </div>
            <div className={styles.bannerItemActions}>
              <TopBannerDropdownMenu
                topBanner={{ id, title, transitionUrl, isActive, sortOrder, imageUrl, groupName }}
                onSelected={onSelectedDropdownMenu}
              />
            </div>
          </div>
        )}
      />
    </Stack>
  </div>
);
